import ConnectivityCheckoutStepPersonalData from '@components/connectivity/ConnectivityCheckoutStepPersonalData';
import ConnectivityCheckoutStepLineData from '@components/connectivity/ConnectivityCheckoutStepLineData';
import ConnectivityCheckoutStepPayment from '@components/connectivity/ConnectivityCheckoutStepPayment';
import ConnectivityCheckoutStepReview from '@components/connectivity/ConnectivityCheckoutStepReview';
import AccordionStepContainer from '@components/common/AccordionStep';
import { ErrorFallback } from '@components/common/ErrorBoundary';
import ErrorBox from '@components/common/ErrorBox';
import { getStep } from '@state/features/accordion.selectors';
import { ConnectivityActionTypes } from '@state/features/common.types';
import Config from '@config';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useDispatch, useSelector } from 'react-redux';
import ConnectivitySummary from './ConnectivitySummary';
const connectivitySteps = Config.connectivitySteps;
const ConnectivityCheckoutPage = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [viewSummary, setViewSummary] = useState(false);
    const [alertErrors, setAlertErrors] = useState([]);
    const { product, registry, coverageAddress, paymentData } = useSelector((state) => state.connectivity);
    const step = useSelector(getStep) || 'personalData';
    useEffect(() => {
        dispatch({ type: ConnectivityActionTypes.FETCH_CONNECTIVITYDATA });
    }, []);
    const handleSummaryClick = () => {
        setViewSummary(!viewSummary);
    };
    const setErrors = (message) => {
        setAlertErrors(message);
    };
    const personalDataSummary = () => {
        let year, month, day;
        let birthday = new Date(registry.birthDate);
        year = birthday.getFullYear();
        month = birthday.getMonth() + 1;
        day = birthday.getDate();
        if (day < 10) {
            day = '0' + day;
        }
        if (month < 10) {
            month = '0' + month;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "address-summary" },
                React.createElement("p", { className: "description" }, t('checkout.shippingaddress.registry.summary')),
                React.createElement("p", null,
                    registry.firstName,
                    " ",
                    registry.lastName,
                    ", ",
                    registry.fiscalCode,
                    ", ",
                    day,
                    "/",
                    month,
                    "/",
                    year),
                React.createElement("p", null,
                    registry.birthPlace,
                    ", ",
                    registry.phone,
                    ", ",
                    registry.email))));
    };
    const lineSummary = () => {
        return (React.createElement("div", { className: "address-summary" },
            React.createElement("p", { className: "description" }, t('connectivity.checkout.linedata.summary')),
            React.createElement("p", null,
                coverageAddress.region,
                ", ",
                coverageAddress.city,
                ", ",
                coverageAddress.stateCode,
                ", ",
                coverageAddress.address)));
    };
    const paymentSummary = () => {
        return (React.createElement("div", { className: "address-summary" },
            React.createElement("p", { className: "description" }, t('connectivity.checkout.payment.summary')),
            React.createElement("p", null, t(`connectivity.checkout.payment.method.${paymentData.paymentMethod.toLowerCase()}.name`)),
            React.createElement("p", null, paymentData.paymentMethod == 'CC' ? registry.email : paymentData.paymentMethod == 'SDD' ? paymentData.iban : '')));
    };
    return (React.createElement("div", { className: "checkoutpage connectivity" },
        React.createElement("div", { className: "checkout-step-container" },
            React.createElement("div", { className: 'checkout--left' },
                React.createElement(ErrorBox, { errors: alertErrors, setErrors: setAlertErrors, ariaLabel: t('common.close') }),
                React.createElement(AccordionStepContainer, { id: 'personalData', openstep: step, title: t('connectivity.checkout.personaldata.title'), editable: step == 'lineData' || step == 'payment' || step == 'review', complete: registry && (step == 'lineData' || step == 'payment' || step == 'review'), description: (step == 'lineData' || step == 'payment' || step == 'review') && registry && personalDataSummary() },
                    React.createElement(ErrorBoundary, { FallbackComponent: ErrorFallback },
                        React.createElement(ConnectivityCheckoutStepPersonalData, Object.assign({}, props, { setErrors: setErrors })))),
                React.createElement(AccordionStepContainer, { id: 'lineData', openstep: step, title: t('connectivity.checkout.linedata.title'), editable: step == 'payment' || step == 'review', complete: coverageAddress && (step == 'payment' || step == 'review'), description: (step == 'payment' || step == 'review') && coverageAddress && lineSummary() },
                    React.createElement(ErrorBoundary, { FallbackComponent: ErrorFallback },
                        React.createElement(ConnectivityCheckoutStepLineData, Object.assign({}, props, { setErrors: setErrors })))),
                React.createElement(AccordionStepContainer, { id: 'payment', openstep: step, title: t('connectivity.checkout.payment.title'), editable: step == 'review', complete: paymentData && paymentData.paymentMethod && step == 'review', description: step == 'review' && paymentData && paymentData.paymentMethod && paymentSummary() },
                    React.createElement(ErrorBoundary, { FallbackComponent: ErrorFallback },
                        React.createElement(ConnectivityCheckoutStepPayment, Object.assign({}, props, { setErrors: setErrors })))),
                React.createElement(AccordionStepContainer, { id: 'review', openstep: step, title: t('connectivity.checkout.review.title'), editable: false, complete: false },
                    React.createElement(ErrorBoundary, { FallbackComponent: ErrorFallback },
                        React.createElement(ConnectivityCheckoutStepReview, Object.assign({}, props, { setErrors: setErrors }))))),
            React.createElement("div", { className: `checkout--right ${viewSummary ? 'view' : ''}` }, product && React.createElement(ConnectivitySummary, { bagItem: product, clicksummary: handleSummaryClick }))),
        React.createElement("div", { className: "checkout-big-ball" }),
        React.createElement("div", { className: "checkout-small-ball" })));
};
export default ConnectivityCheckoutPage;
